import { render, staticRenderFns } from "./LayoutPix.vue?vue&type=template&id=1911eb0e"
import script from "./LayoutPix.vue?vue&type=script&lang=js"
export * from "./LayoutPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports